import { IAxiosResponse, IPaginator } from '../store/ducks/root.types'
import { Patient } from '../store/application/models/patient/patient'
import axiosInstance from './axios'

class PatientService {

  constructor(private apiVersion: string = 'v1') {
  }
  public async getAll(
    paginator?: IPaginator,
  ): Promise<IAxiosResponse<Patient[]>> {
    const params: URLSearchParams = this.buildParams(paginator)

    return axiosInstance
      .get(`${this.apiVersion}/patients`, { params })
      .then((response) => {
        return {
          data: response.data.map((data: any) => new Patient().fromJSON(data)),
          headers: response.headers
        }
      })
  }
  public async create(newPatient: Patient): Promise<IAxiosResponse<Patient>> {
    return axiosInstance
      .post(`${this.apiVersion}/patients`, newPatient)
      .then((response) => {
        return {
          data: new Patient().fromJSON(response.data),
          headers: response.headers
        }
      })
  }
  public async getById(patientId: string): Promise<IAxiosResponse<Patient>> {
    return axiosInstance
      .get(`${this.apiVersion}/patients/${patientId}`)
      .then((response) => {
        return {
          data: new Patient().fromJSON(response.data),
          headers: response.headers
        }
      })
  }

  public async updadePatient(newPatient: Patient): Promise<IAxiosResponse<Patient>> {
    return axiosInstance
      .patch(`${this.apiVersion}/patients/${newPatient.id}`, newPatient)
      .then((response) => {
        return {
          data: new Patient().fromJSON(response.data),
          headers: response.headers
        }
      })
  }


  public buildParams(paginator?: IPaginator, filter?): URLSearchParams {
    const params = new URLSearchParams()
    if (paginator) {
      const hasSearch = (paginator?.search?.key === 'name' && paginator?.search?.value) ||
        (paginator?.search?.key === 'cpf' && paginator?.search?.value)
      if (paginator.page && !hasSearch) {
        params.append('page', String(paginator.page + 1))
      }
      if (paginator.rows) {
        params.append('limit', String(paginator.rows))
      }
      if (hasSearch) {
        params.append(`${paginator?.search?.key.toLowerCase()}`, `*${paginator?.search?.value}*`)
      }
    }
    return params
  }
}
const patientService = new PatientService()
export default patientService